import { Divider, Paper, Stack } from '@mui/material'
import ExamDetails from './ExamDetails'
import { Fragment } from 'react/jsx-runtime'
import { QcTaskState, QcTimepointContainerSubmission } from '@common/config/api/client'
import { SPACING } from '@common/theme/spacing'

export default function ExamDetailsList({
  qcTaskOrder,
  qcTaskStatus,
  timepointSubmissionId,
  container,
}: {
  qcTaskOrder: number
  qcTaskStatus: QcTaskState
  timepointSubmissionId: string
  container: QcTimepointContainerSubmission
}) {
  return (
    <Paper
      sx={{
        borderRadius: SPACING.borderRadiusXxl,
        bgcolor: 'paper.main',
      }}
    >
      <Stack spacing={SPACING.examDetailsListSpacing}>
        {container.exam_metadata.map((exam, index) => {
          return (
            <Fragment key={index}>
              {index !== 0 && <Divider />}
              <ExamDetails
                qcTaskOrder={qcTaskOrder}
                qcTaskStatus={qcTaskStatus}
                timepointSubmissionId={timepointSubmissionId}
                exam={exam}
                container={container}
              />
            </Fragment>
          )
        })}
      </Stack>
    </Paper>
  )
}
